import { Colors, Services } from '@sigma-frontend-libs/commons'

import { icons, permissionPresets } from '@/utils'

import flag from '@/components/flag'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'

function renderRegion(h) {
  return h(
    sticker,
    {
      props: {
        value: `${this.value.regionCode} / ${this.value.regionName}`,
        label: this.getTranslate(`${Services['country-regions']}.labels.region`),
        icon: icons.location_on,
        iconColor: Colors.grey,
        to: {
          name: `${Services['country-regions']}.single`,
          params: { id: this.value.id }
        }
      }
    }
  )
}
function renderFlag(h) {
  return h(
    flag,
    {
      props: {
        value: this.value.countryCode,
        squircle: true
      }
    }
  )
}
function renderCountry(h) {
  if (this.viewport.size.width > 425) {
    return h(
      sticker,
      {
        props: {
          value: `${this.value.countryCode} / ${this.value.countryName}`,
          label: this.getTranslate(`${Services['country-regions']}.labels.country`)
        },
        scopedSlots: {
          icon: () => {
            return renderFlag.call(this, h)
          }
        }
      }
    )
  }
}
function renderTimeZone(h) {
  if (this.viewport.size.width > 460) {
    return h(
      sticker,
      {
        props: {
          value: this.value.timeZone,
          label: this.getTranslate(`${Services['country-regions']}.labels.timeZone`),
          icon: icons.schedule,
          iconColor: Colors.grey
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${Services['country-regions']}-item__info`
    },
    [
      renderRegion.call(this, h),
      renderCountry.call(this, h),
      renderTimeZone.call(this, h)
    ]
  )
}

function renderCreatedAt(h) {
  if (this.viewport.size.width > 600) {
    return h(
      date,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}

function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: Services['country-regions'],
        accept: permissionPresets.true,
        removeCallback: () => {
          this.$emit('remove', this.value.id)
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`service-template-item ${Services['country-regions']}-item`]: true,
        'hover-parent hover-parent--opacity': this.viewport.breakpoint.mdUp
      }
    },
    [
      renderInfo.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
